import { useNavigate } from "react-router-dom";
import { Breadcrumb as AntBreadcrumb, Typography } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { VaultFolder } from "@/types";
import { ROUTES } from "@/utils/constants";

const { Text } = Typography;

interface BreadcrumbProps {
  folders: VaultFolder[];
  itemCount?: number;
  isLoading?: boolean;
}

export default function Breadcrumb({
  folders,
  itemCount,
  isLoading = false,
}: BreadcrumbProps) {
  const navigate = useNavigate();

  const handleNavigate = (folderId: string | null) => {
    if (folderId) {
      navigate(ROUTES.folder(folderId));
    } else {
      navigate(ROUTES.files);
    }
  };

  const items = [
    {
      key: "root",
      title: (
        <span
          style={{ cursor: "pointer" }}
          onClick={() => handleNavigate(null)}
        >
          <HomeOutlined style={{ marginRight: 4 }} />
          All files
        </span>
      ),
    },
    ...folders.map((folder, index) => ({
      key: folder.id,
      title:
        index === folders.length - 1 ? (
          <span>{folder.name}</span>
        ) : (
          <span
            style={{ cursor: "pointer" }}
            onClick={() => handleNavigate(folder.id)}
          >
            {folder.name}
          </span>
        ),
    })),
  ];

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
      }}
    >
      <AntBreadcrumb items={items} />

      {!isLoading && itemCount !== undefined && (
        <Text type="secondary" style={{ fontSize: 12 }}>
          ({itemCount} {itemCount === 1 ? "item" : "items"})
        </Text>
      )}
    </div>
  );
}
